/**
 * 제어·모니터링 화면의 표시값.
 *
 * 🔴 **여기는 전부 계약 없음이다**(README §10-2).
 *    조그·축 이동 패드는 orchestrator 에 L1 경로가 **0건**이고
 *    (`module_service.openapi.yaml` 의 `/positions` 는 L3 모듈 로컬 계약이라 L1 이 부르지 않는다),
 *    비전 영상 스트림 엔드포인트도 양쪽 계약 어디에도 없다.
 *    ⇒ 화면은 그리되 **조작 버튼은 비활성 + 사유**가 맞다. 실물 경로는 팀장 보고 대상.
 */
import type { AxisState, VisionFeed } from '@ctcells/contract'

/** 3축 갠트리 위치. 레일 0~600 mm 를 세 정거장(입구 트레이 · 모듈 · 출구 트레이)에 대응한다 */
export const CONTROL_AXES: AxisState[] = [
  { axis: 'x', position_mm: 305, target_mm: 305 },
  { axis: 'y', position_mm: 0, target_mm: 0 },
  { axis: 'z', position_mm: 42, target_mm: 42 },
]

/**
 * 비전 카메라 3대. cam-1 원심 · cam-2 어셈블러 · cam-3 염색기.
 * 오버레이가 모듈마다 다르다(원심 = 로터 슬롯 4 / 어셈블러 = 틸트 스테이지·TC / 염색기 = 셰이커 3×3).
 */
export const VISION_FEEDS: VisionFeed[] = [
  { camera_id: 'cam-1', module_id: 'cent', live: true, width: 1280, height: 720 },
  { camera_id: 'cam-2', module_id: 'asm', live: true, width: 1280, height: 720 },
  { camera_id: 'cam-3', module_id: 'stain', live: true, width: 1280, height: 720 },
]

/**
 * 모듈별 **텔레메트리** 표시 항목.
 * `ModuleSnapshot.telemetry` 는 `additionalProperties: true` 라 **계약이 키를 정하지 않는다** —
 * 무엇을 보일지는 화면이 정한다. 그 목록을 여기 한 곳에 모은다.
 * 값은 `DEMO_SCENARIOS[*].modules[*].telemetry` 에서 읽고, 없으면 `—` 로 떨어뜨린다.
 *
 * 🔴 **소모품·시약 보관 온도는 여기 없다**(정정 2026-09-21). 종전에는 `tc_remaining` ·
 *    `tip_remaining` · `reagent_storage_celsius` 셋이 이 표에 있었는데 **전부 틀렸다** —
 *    셋 다 `telemetry` 가 아니라 **다른 주머니**에 산다:
 *    · `tc_remaining` · `tips_remaining` → `ModuleSnapshot.consumables`(칸 이름은 **복수**다)
 *    · 시약 보관 온도 → `ModuleSnapshot.reagent_storage.actual_celsius`
 *      (계약이 「telemetry 자유형에 얹지 않는다」고 못박은 자리다)
 *    그래서 그 세 줄은 실물에서 **영영 `—`** 였다. 주머니 대응은 `METRIC_SPECS.source` 가 쥔다.
 */
export const TELEMETRY_KEYS: Record<string, string[]> = {
  cent: ['rotor_rpm', 'rotor_rcf', 'temperature_celsius', 'door_closed'],
  asm: ['uv_intensity_mw_cm2', 'tilt_angle_deg'],
  stain: ['shaker_rpm', 'slider_position'],
  robot: ['joint_1', 'joint_2', 'joint_3', 'joint_4', 'joint_5', 'joint_6'],
}
